import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-lg font-medium" }
const _hoisted_2 = { class: "text-sm mt-2" }
const _hoisted_3 = { class: "flex justify-between items-center mt-6" }
const _hoisted_4 = { class: "mt-6 border border-light-3 rounded-t overflow-hidden" }
const _hoisted_5 = { class: "grid grid-cols-14 gap-2 text-left text-dark-2 h-10 bg-light-3 px-3" }
const _hoisted_6 = { class: "col-span-1 flex items-center" }
const _hoisted_7 = { class: "text-sm font-normal col-span-3 flex items-center" }
const _hoisted_8 = { class: "text-sm font-normal col-span-3 flex items-center" }
const _hoisted_9 = { class: "text-sm font-normal col-span-2 flex items-center" }
const _hoisted_10 = { class: "text-sm font-normal col-span-2 flex items-center" }
const _hoisted_11 = { class: "text-sm font-normal col-span-2 flex items-center" }
const _hoisted_12 = { class: "py-3 col-span-1 flex items-center" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex items-center col-span-3" }
const _hoisted_15 = { class: "col-span-3 flex items-center text-dark-3" }
const _hoisted_16 = { class: "col-span-2 flex items-center text-dark-3" }
const _hoisted_17 = { class: "col-span-2 flex items-center text-dark-3" }
const _hoisted_18 = { class: "col-span-2 flex items-center text-dark-3" }
const _hoisted_19 = {
  key: 1,
  class: "h-100 flex items-center justify-center"
}
const _hoisted_20 = {
  width: 64,
  viewBox: "0 0 768 768",
  fill: "none"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  class: "custom-loader-pulse",
  d: "M384 347.127L475.79 242H526V526H448.331V391.061L384 458.53L319.669 391.061V526H242V242H292.994L384 347.127Z"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", {
  class: "custom-loader-outline",
  d: "M384 347.127L475.79 242H526V526H448.331V391.061L384 458.53L319.669 391.061V526H242V242H292.994L384 347.127Z"
}, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "h-100 flex items-center justify-center"
}
const _hoisted_25 = {
  key: 3,
  class: "h-100 flex items-center justify-center"
}
const _hoisted_26 = { class: "mt-4 h-4 flex justify-start items-center" }
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = { class: "flex justify-end items-center w-full mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_modal = _resolveComponent("app-modal")!

  return (_openBlock(), _createBlock(_component_app_modal, {
    onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeDialog(null))),
    size: "w-238"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("components.addProductsModal.chooseYourProducts")), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("components.addProductsModal.chooseProductsFromStore")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_app_search, {
          modelValue: _ctx.dynamicProductsSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dynamicProductsSearch) = $event)),
          class: "flex-1 mr-3"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_app_select, {
          modelValue: _ctx.dynamicProductsCategory,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dynamicProductsCategory) = $event)),
          options: _ctx.categoryOptions,
          placeholder: _ctx.$t('components.addProductsModal.selectCategory'),
          class: "w-100"
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.dynamicProductsList.length)
              ? (_openBlock(), _createBlock(_component_checkbox, {
                  key: 0,
                  modelValue: _ctx.selectAllProducts,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectAllProducts) = $event)),
                  binary: true
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("components.addProductsModal.name")), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("components.addProductsModal.sku")), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("components.addProductsModal.category")), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("components.addProductsModal.price")), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("components.addProductsModal.productId")), 1)
        ]),
        _createElementVNode("div", {
          class: "overflow-auto h-100",
          onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
        }, [
          (_ctx.dynamicProductsList.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dynamicProductsList, (product, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: product.id,
                  class: _normalizeClass(["grid grid-cols-14 gap-2 text-sm px-3", [index % 2 ? 'bg-light-1' : 'bg-white']])
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_checkbox, {
                      name: "selected-products",
                      modelValue: _ctx.selectedProducts,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedProducts) = $event)),
                      value: product.id
                    }, null, 8, ["modelValue", "value"]),
                    _createElementVNode("img", {
                      src: 
                                    product.imageUrl ??
                                        '/assets/img/placeholder.svg'
                                ,
                      alt: "",
                      class: "w-7.5 h-7.5 ml-2 rounded",
                      onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.productFallbackImage && _ctx.productFallbackImage(...args)))
                    }, null, 40, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(product.title), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(product.sku), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(product.productCategory
                                    ? product.productCategory.name
                                    : "n/a"), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.currency) + " " + _toDisplayString(product.price), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(product.id), 1)
                ], 2))
              }), 128))
            : (_ctx.loadingProducts)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_23))
                ]))
              : (_ctx.dynamicProductsSearch.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("components.addProductsModal.sorryText")) + " “" + _toDisplayString(_ctx.dynamicProductsSearch) + "”. ", 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("components.addProductsModal.startSearchingText")), 1)
                  ]))
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_26, [
        (_ctx.selectedProducts.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.selectedProducts.length) + " " + _toDisplayString(_ctx.$t("components.addProductsModal.productsSelected")), 1),
              _createElementVNode("span", {
                class: "text-sm font-bold text-red-600 cursor-pointer ml-4",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetSelectedProducts && _ctx.resetSelectedProducts(...args)))
              }, _toDisplayString(_ctx.$t("components.addProductsModal.clearAll")), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_app_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeDialog(null))),
          "button-style": "transparentUnderline",
          class: "mr-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("general.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_app_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeDialog(_ctx.selectedProducts))),
          "button-style": "primary",
          disabled: !_ctx.selectedProducts.length
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("components.addProductsModal.allProducts")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}